import type { DatabaseChange, DatabaseChanges, ValidatorsType } from "shelving";
import { ATTEMPT_SCHEMA, CHALLENGE_SCHEMA, PROGRESS_SCHEMA } from "./challenge.js";
import { COMMENT_SCHEMA } from "./comment.js";
import { GROUP_SCHEMA, MEMBER_SCHEMA, MESSAGE_SCHEMA } from "./group.js";
import { LEADERBOARD_SCHEMA } from "./leaderboard.js";
import { LIST_SCHEMA } from "./list.js";
import { NOTE_SCHEMA } from "./note.js";
import { NOTIFICATION_SCHEMA } from "./notification.js";
import { POST_SCHEMA } from "./post.js";
import { FOLLOWING_SCHEMA, PROFILE_SCHEMA } from "./profile.js";
import { REACTION_SCHEMA, REACTOR_SCHEMA } from "./reaction.js";
import { EARNED_SCHEMA, REWARD_SCHEMA } from "./reward.js";
import { USER_SCHEMA } from "./user.js";
import { SHORTCUT_SCHEMA, USERNAME_SCHEMA } from "./username.js";

/** Schemas that define the layout of our database. */
export const SCHEMAS = {
	user: USER_SCHEMA,
	username: USERNAME_SCHEMA,
	shortcut: SHORTCUT_SCHEMA,
	profile: PROFILE_SCHEMA,
	following: FOLLOWING_SCHEMA,
	group: GROUP_SCHEMA,
	member: MEMBER_SCHEMA,
	message: MESSAGE_SCHEMA,
	post: POST_SCHEMA,
	comment: COMMENT_SCHEMA,
	reaction: REACTION_SCHEMA,
	reactor: REACTOR_SCHEMA,
	challenge: CHALLENGE_SCHEMA,
	leaderboard: LEADERBOARD_SCHEMA,
	attempt: ATTEMPT_SCHEMA,
	progress: PROGRESS_SCHEMA,
	reward: REWARD_SCHEMA,
	earned: EARNED_SCHEMA,
	note: NOTE_SCHEMA,
	list: LIST_SCHEMA,
	notification: NOTIFICATION_SCHEMA,
};

/** Schemas as a type. */
export type Schemas = ValidatorsType<typeof SCHEMAS>;

/** Set of changes to the database. */
export type SchemaChange = DatabaseChange<Schemas>;

/** Set of changes to the database. */
export type SchemaChanges = DatabaseChanges<Schemas>;

/** Re-exports. */
export * from "./challenge.js";
export * from "./comment.js";
export * from "./counter.js";
export * from "./entity.js";
export * from "./group.js";
export * from "../util/keyword.js";
export * from "./leaderboard.js";
export * from "./list.js";
export * from "./markup.js";
export * from "./misc.js";
export * from "./note.js";
export * from "./notification.js";
export * from "./post.js";
export * from "../util/privacy.js";
export * from "./profile.js";
export * from "./reaction.js";
export * from "./reward.js";
export * from "./unit.js";
export * from "./user.js";
export * from "./username.js";
